import { render, staticRenderFns } from "./table_of_contents_heading.vue?vue&type=template&id=1a56cd30&vue3"
import script from "./table_of_contents_heading.vue?vue&type=script&lang=js&vue3"
export * from "./table_of_contents_heading.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports